import { render, staticRenderFns } from "./OsappAnimationViewContentBlockForm.vue?vue&type=template&id=8d80d88a&"
import script from "./OsappAnimationViewContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./OsappAnimationViewContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports